export default __webpack_public_path__ + "static/media/archive.67676af0.svg";